import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { App } from "./App";
import { queryClient } from "./lib/query-client";
import { installChunkRecovery, clearChunkRecoveryFlag } from "./lib/chunk-recovery";
import { installMutationFetch } from "@wedding/shared";
import "./i18n";
import "./globals.css";

/**
 * Uygulamanın giriş noktası — YALNIZ bootstrap.
 *
 * ⚠️ Buradan hiçbir şey EXPORT ETME. Bu modül import edildiği anda `createRoot()`
 * çağırır, CSS yükler ve service-worker kaydeder; bir sayfa buradan bir değer
 * import ederse o sayfa test ortamında import EDİLEMEZ hale gelir (2026-07-28'e
 * kadar `queryClient`/`staleTimes` burada yaşıyordu ve beş dosya buradan import
 * ediyordu). Paylaşılan durum `lib/query-client.ts` gibi yan etkisiz modüllerde
 * yaşar.
 */

// Deploy anında bozulmuş bir lazy chunk sayfayı komple açılmaz hale getiriyordu
// (Pages eksik asset'e 200+HTML dönüyor, tarayıcı 4 saat cache'liyor).
// Tek seferlik otomatik yenileme — ayrıntı: lib/chunk-recovery.ts
installChunkRecovery();

// Tüm /api/* istekleri ortak değişiklik katmanından geçer: Idempotency-Key + aynı anda iki kez
// gönderilen aynı istek (çift tık, iki kez LCV) tek istek — ayrıntı: packages/shared/src/mutation-fetch.ts
installMutationFetch();

// PROD only: in dev the SW fights Vite HMR and caches surprise you mid-debug.
if (import.meta.env.PROD && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
    // Sayfa açıldıysa kurtarma hakkını iade et (sonraki deploy için).
    clearChunkRecoveryFlag();
  });
}

// HMR-safe root: cache the root on the container so Vite hot reload doesn't
// call createRoot twice on the same element.
const container = document.getElementById("root")! as HTMLElement & { __reactRoot?: ReactDOM.Root };
const root = container.__reactRoot ?? (container.__reactRoot = ReactDOM.createRoot(container));

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
